import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilserviceService } from 'app/services/utilservice.service';

@Injectable()
export class JwtinterceptorInterceptor implements HttpInterceptor {

  constructor(private auth: UtilserviceService) { }  
    
  intercept(request : HttpRequest<any>,next:HttpHandler) : Observable<HttpEvent<any>>{ 
    let user = JSON.parse(this.auth.getCurrentUser());
    if(user){
      const currentUserToken = user['token'];
    
      request = request.clone({
        setHeaders : {
            Authorization : `Bearer ${currentUserToken}`             
        }            
      });
    }      
    
      
    return next.handle(request);   
  }
}
